import styled from "styled-components";

function getBackgroundColour(props) {
    if (props.disabled) {
        return "#e4e4e4";
    }

    if (props.inverted) {
        return props.theme.tertiary;
    }

    return props.theme.primary;
}

export const Button = styled.a`
    background: ${props => getBackgroundColour(props)} !important;
    color: ${props => (props.inverted ? props.theme.secondary : props.theme.tertiary)} !important;
    text-align: center;
    text-decoration: none;
    padding: 0.5em;
    display: block;
    min-width: 100px;
    max-width: 280px;
    margin: 0 auto 1em;
    cursor: ${props => (props.disabled ? "not-allowed" : "pointer")};

    ${props => (props.width ? `width: ${props.width};` : "")}
    ${props => (props.floatRight ? "float: right;" : "")}
    ${props => (props.marginLeft ? `margin-left: ${props.marginLeft}px;` : "")}
    ${props => (props.marginRight ? `margin-right: ${props.marginRight}px;` : "")}
    ${props => (props.inverted ? "border: 1px solid #aaa;" : "")}

    :focus {
        outline: 1px solid #80bcf9;
    }

    i {
        color: ${props => (props.inverted ? props.theme.primary : props.theme.tertiary)};
        float: right;
        font-size: 1.5em;
        padding-left: 0.5em;
        line-height: 0.75;
    }
`;
